export default {
    md: 768,
    lg: 1024,
    xl: 1367
};
